module.exports = __webpack_public_path__ + "img/food_coffe.6756d106.png";